import { useState } from "react";
import { ActivitySidebar } from "./ActivitySidebar";
import { SettingsSidebar } from "./SettingsSidebar";
import type { TurnLogEntry } from "./turnLog";

/**
 * The right-hand rail: what just happened, and how the assistant is configured.
 *
 * Two tabs in one rail rather than two rails — with up to three model columns, width
 * is the scarce resource, and a second permanent rail would eat it for something you
 * touch once a week.
 */
export function AssistantRail({
  entries,
  onClearLog,
}: {
  entries: TurnLogEntry[];
  onClearLog: () => void;
}) {
  const [tab, setTab] = useState<"activity" | "settings">("activity");

  return (
    <aside className="flex w-72 shrink-0 flex-col border-l border-maven-gray-100 dark:border-maven-gray-800 bg-maven-gray-100/40 dark:bg-maven-gray-950/60">
      <div className="flex border-b border-maven-gray-100 dark:border-maven-gray-800">
        {(["activity", "settings"] as const).map((name) => (
          <button
            key={name}
            onClick={() => setTab(name)}
            aria-pressed={tab === name}
            className={`flex-1 px-3 py-2.5 text-xs font-medium uppercase tracking-wide transition-colors ${
              tab === name
                ? "bg-white dark:bg-maven-gray-800 text-maven-gray-800 dark:text-maven-gray-100"
                : "text-maven-gray-500 dark:text-maven-gray-500 hover:text-maven-gray-800"
            }`}
          >
            {name}
          </button>
        ))}
      </div>

      {tab === "activity" ? (
        <ActivitySidebar entries={entries} onClear={onClearLog} />
      ) : (
        <SettingsSidebar />
      )}
    </aside>
  );
}
